export type LanguageCode = "en" | "en-GB" | "es" | "fr" | "de" | "zh" | "ru" | "ja" | "ko";

export interface LanguageOption {
  code: LanguageCode;
  label: string;
  english: string;
  flag: string;
}

export const LANGUAGES: LanguageOption[] = [
  { code: "en",    label: "English",      english: "English",            flag: "🇺🇸" },
  { code: "en-GB", label: "English (UK)", english: "British English",    flag: "🇬🇧" },
  { code: "es",    label: "Español",      english: "Spanish",            flag: "🇪🇸" },
  { code: "fr",    label: "Français",     english: "French",             flag: "🇫🇷" },
  { code: "de",    label: "Deutsch",      english: "German",             flag: "🇩🇪" },
  { code: "zh",    label: "中文",         english: "Simplified Chinese", flag: "🇨🇳" },
  { code: "ru",    label: "Русский",      english: "Russian",            flag: "🇷🇺" },
  { code: "ja",    label: "日本語",       english: "Japanese",           flag: "🇯🇵" },
  { code: "ko",    label: "한국어",       english: "Korean",             flag: "🇰🇷" },
];

export const LANGUAGE_BY_CODE: Record<string, LanguageOption> = Object.fromEntries(
  LANGUAGES.map((l) => [l.code, l]),
);

export const RTL_LANGUAGES: LanguageCode[] = [];
